<template>
  <div class="ds-chart-box">
    <div class="ds-chart-box__heading">
      <div class="ds-chart-box__main">
        <h1 class="ds-chart-box__title">
          {{ title }}
        </h1>
        <p class="ds-chart-box__description">
          {{ description }}
        </p>
      </div>

      <div class="ds-chart-box__primary-action">
        <slot name="primary-action" />
      </div>
    </div>

    <div class="ds-chart-box__secondary-action">
      <slot name="secondary-action" />
    </div>

    <slot />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'DsChartBox',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    description: {
      type: String
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted() {
    // @ts-ignore
    document.documentElement.setAttribute(
      'data-color-theme',
      this.dark ? 'dark' : ''
    );
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/ChartBox.scss';
</style>
